<styles-smart-table
  #smartTable
  [datasource]="sows.items"
  [mainColumns]="columnBuilder.getAllColumnNames()"
  [showColumnHeaders]="showColumnHeaders"
  matSort
  (matSortChange)="updateSort($event)"
  [matSortActive]="buildSort()?.active"
  [matSortDirection]="buildSort()?.direction"
>
  <ng-container matColumnDef="spaceName">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnBuilder.getAllColumnNames().length || 0">
      <div class="container">
        <mat-icon class="color-icon"> home </mat-icon>
        {{$any(element)?.name }}
        <!-- <framework-space-chip [spaceType]="element | workSpaceType"> </framework-space-chip> -->
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="organization">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="organization"
      mat-sort-header
    >
      Organization
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="organization">
      <styles-icon-value-caption caption="Organization" icon="corporate_fare" *ngIf="element.feedDetails">
        {{ $any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName}}
      </styles-icon-value-caption>
    </td>
  </ng-container>

  <ng-container matColumnDef="startDate">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="startDate">
      Start Date
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="startDate">
      <styles-icon-value-caption caption="Start Date" icon="date_range">
        {{ $any(element)?.startDate | date : 'mediumDate' }}
      </styles-icon-value-caption>
    </td>
  </ng-container>

  <ng-container matColumnDef="contractualEndDate">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="contractualEndDate"
      mat-sort-header
    >
      Contractual End Date
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="contractualEndDate">
      <styles-icon-value-caption caption="Contractual End Date" icon="date_range">
        <ng-container *ngIf="!isRolling(element); else rolling">
          {{ $any(element)?.contractualEndDate | date : 'mediumDate' }}
        </ng-container>
        <ng-template #rolling> Rolling </ng-template>
      </styles-icon-value-caption>
    </td>
  </ng-container>

  <ng-container matColumnDef="workThroughDate">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="workThroughDate">
      Work Through Date
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="workThroughDate">
      <styles-icon-value-caption caption="Work Through Date" icon="date_range">
        <ng-container *ngIf="!isRolling(element); else rolling">
          {{ $any(element)?.workThruDate | date : 'mediumDate' }}
        </ng-container>
        <ng-template #rolling> Rolling </ng-template>
      </styles-icon-value-caption>
    </td>
  </ng-container>

  <ng-container matColumnDef="default">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="default"
      mat-sort-header
    >
      Name
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="default">
      <a [routerLink]="element | findRoute">
        <div>
          <div class="title ellipsis-text">{{$any(element).name}}</div>
          <div class="sub-title">
            <mat-icon class="color-icon"> home </mat-icon>
            <div class="ellipsis-text">{{$any(element)?.contractType?.name }}</div>
            <framework-space-chip [spaceType]="element | workSpaceType"> </framework-space-chip>
          </div>
        </div>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="owner">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="owner" mat-sort-header>
      Owner
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="owner">
      <span class="owner-wrapper">
        <framework-person-image [person]="element.owner" size="33px"></framework-person-image>
        <span class="name">{{ element.owner.name }}</span>
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="status"
      mat-sort-header
    >
      Status
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="status">
      <framework-work-status-chip [workStatus]="$any(element)?.status"></framework-work-status-chip>
    </td>
  </ng-container>

  <ng-container matColumnDef="units">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="units" mat-sort-header>
      Units
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="units">
      <div class="units-container">
        <shared-layered-number-description
          *ngIf="$any(element)?.units?.totalUnits > 0"
          [number]=" ($any(element)?.workThruDate | isRolling) ?($any(element).units?.totalUnits | unitsPerMonth : $any(element).startDate : $any(element).workThruDate |
          number : '1.0-0') + 'pcm' : $any(element).units?.totalUnits | number : '1.0-2'"
          description="Total Units"
        >
        </shared-layered-number-description>

        <shared-layered-number-description
          *ngIf="($any(element)?.workThruDate | isRolling) === false && $any(element)?.units?.incompletedUnits > 0"
          [number]=" $any(element).units?.incompletedUnits | number : '1.0-2'"
          description="Remaining"
        >
        </shared-layered-number-description>

        <shared-layered-number-description
          *ngIf="$any(element)?.units?.completedUnits > 0"
          [number]="$any(element).units?.completedUnits | number : '1.0-2'"
          description="Completed"
        >
        </shared-layered-number-description>

        <shared-layered-number-description
          *ngIf="$any(element)?.units?.completedTargetOffset && $any(element)?.units?.completedTargetOffset !== 0"
          [number]="$any(element).units?.completedTargetOffset | number : '1.0-2'"
          description="Ahead / Behind"
        >
        </shared-layered-number-description>

        <shared-layered-number-description
          *ngIf="$any(element).units?.targetUnits && $any(element).units?.totalUnits && $any(element).units?.targetUnits !== 0 && $any(element).units?.totalUnits !== 0"
          [number]="(getPacePercentage($any(element).units?.targetUnits, $any(element).units?.totalUnits ,$any(element).units?.completedPercent) | percent : '1.0-2') "
          description="Pace Offset"
          [ngClass]="getPacePercentage($any(element).units?.targetUnits, $any(element).units?.totalUnits ,$any(element).units?.completedPercent) >= 0 ? 'green' : 'red'"
        >
        </shared-layered-number-description>
      </div>
      <!-- <div class="task-box">
        <shared-units-list [units]="element.units" *ngIf="element?.units?.totalUnits > 0; else noUnits">
          {{element.units?.totalUnits | number : '1.0-2'}}
        </shared-units-list>
        <ng-template #noUnits> - </ng-template>
      </div> -->
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="actions"></th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="actions">
      <shared-listing-action-dropdown
        *ngIf="($any(element)?.actions)!.length > 0"
        [actions]="$any(element)?.actions"
        [masterProject]="element | findMaster"
        [project]="element"
        location="sow"
        level="project"
      >
      </shared-listing-action-dropdown>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-owner">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <framework-person-image [person]="group.group" size="40px"></framework-person-image>
        {{ group.group.name }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-date">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper"><mat-icon>calendar_today</mat-icon>{{group.group | date : 'MMMM y'}}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-organization">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <mat-icon>corporate_fare</mat-icon>
        {{ group.group.organizationName || group.group.feedName}}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-status">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <framework-work-status-chip [workStatus]="group.group"></framework-work-status-chip>
      </div>
    </td>
  </ng-container>
</styles-smart-table>
